/*
  Copyright (c) 2021 Christer Johansson of Sweden Inc.

  Permission is hereby granted, free of charge, to any person obtaining a copy of
  this software and associated documentation files (the "Software"), to deal in
  the Software without restriction, including without limitation the rights to
  use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
  the Software, and to permit persons to whom the Software is furnished to do so,
  subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
  FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
  COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
  IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
  CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/views/Login";
import Register from "./components/views/Register";
import Forgot from "./components/views/Forgot";
import { isUserLoggedIn } from "./services/AuthService";
import StrategiesSheet from "./components/views/StrategiesSheet";
import Ticker from "./components/views/Ticker";
import Main from "./components/views/Main";
import Marketplace from "./components/views/Marketplace";
import Trange from "./components/views/Trange";
import Shark from "./components/views/Shark";
import TickerHistorical from "./components/views/TickerHistorical";
import TickerIndicatorHistorical from "./components/views/TickerIndicatorHistorical";
import GaugeChart from "./components/views/GaugeChart";

const App = () => {

  // eslint-disable-next-line react/prop-types
  function AuthenticatedRoute({children}) {

    const isAuth = isUserLoggedIn();

    if (isAuth) {
      return children;
    }

    return <Navigate to="/" />
  }

  return (
    <Router>
      <Routes>
          {/* http://localhost:8080/api/auth/login */}
          <Route path="/login" element={<Login />} />
          {/* http://localhost:8080/api/auth/register */}
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<Forgot />} />
          {/* http://localhost:8080/api/strategiessheet */}
          <Route path="/strategiessheet" element={
            <AuthenticatedRoute>
              <StrategiesSheet />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/tickers */}
          <Route path="/tickers" element={
            <AuthenticatedRoute>
              <Ticker />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/tickerhistoricals */}
          <Route path="/tickerhistoricals" element={
            <AuthenticatedRoute>
              <TickerHistorical />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/tickerindicatorhistoricals */}
          <Route path="/tickerindicatorhistoricals" element={
              <AuthenticatedRoute>
                  <TickerIndicatorHistorical />
              </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/tickers */}
          <Route path="/tranges" element={
            <AuthenticatedRoute>
              <Trange />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/metadata */}
          <Route path="/shark" element={
            <AuthenticatedRoute>
              <Shark />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/marketplace */}
          <Route path="/marketplace" element={
            <AuthenticatedRoute>
              <Marketplace />
            </AuthenticatedRoute>
            }
          />
          {/* http://localhost:8080/api/*** */}
          <Route path="/gaugechart" element={
              <AuthenticatedRoute>
                  <GaugeChart />
              </AuthenticatedRoute>
          }
          />
          <Route path="/abrfx" element={
            <AuthenticatedRoute>
              <Main />
            </AuthenticatedRoute>
            }
          />
          <Route path="/" element={<Login />} />
      </Routes>
    </Router>
  );
};

export default App;
